module.exports = __webpack_public_path__ + "img/NY.dc91a0ac.png";